import React, { useEffect, useState, useRef } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import OtherService from "../services/Other";
import OrderService from "../services/Order";
import Loader from "../component/Loader";
import RegistrationService from "../services/registration";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import { useNavigate } from "react-router-dom";
import { Home } from "react-feather";
import toast from "react-hot-toast";
import DefaultImage from "../assets/images/productDefault.png";
import Button from "react-bootstrap/Button";

const AddressList = () => {
  const ele = useRef(null);
  const [isAddress, setIsAddress] = useState([]);
  const [isSelectedAddress, setIsSelectedAddress] = useState([]);
  const [isEditAddress, setIsEditAddress] = useState(false);
  const [isUser, setIsUser] = useState({ full_name: "", phone: "" });
  // const [loading, setLoading] = useState(true);
  const [isSelectedAddressChoose, setIsSelectedAddressChoose] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState({ id: "", title: "" });
  const [borderActive, setBorderActive] = useState(true);

  // --------------------------
  const [myOrderData, setMyOrderData] = useState([]);
  const [myOrderNoData, setMyOrderNoData] = useState();
  const [hasData, sethasData] = useState(false);
  const [orderTrack, setOrderTrack] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSelectedProduct, setIsSelectedProduct] = useState();
  const [isSelectedProductTrack, setIsSelectedProductTrack] = useState();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isTrackModalOpen, setIsTrackModalOpen] = useState(false);
  const [isSelectedProductReviewOrderId, setIsSelectedProductReviewOrderId] =
    useState();
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertConfirm, setShowAlertConfirm] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [visibleItemCount, setVisibleItemCount] = useState(12);
  const [confirmReceipt, setConfirmReceipt] = useState(null);
  const [productConditionSelect, setproductConditionSelect] = useState(null);
  const [overAllExperience, setoverAllExperience] = useState(undefined);
  const [isTextArea, setIsTextArea] = useState("");
  const [isReason, setIsReason] = useState({ id: "", title: "" });
  const [isReasonList, setIsReasonList] = useState([]);
  const [complainImage, setComplainImage] = useState(null);
  const [complainImageTwo, setComplainImageTwo] = useState(null);
  const [experienceValidationError, setexperienceValidationError] =
    useState("");
  const [receiptValidationError, setReceiptValidationError] = useState("");
  const [productConditionValidationError, setProductConditionValidationError] =
    useState("");
  const [reasonValidationError, setReasonConditionValidationError] =
    useState("");
  const [productImgValidationError, setProductImgValidationError] =
    useState("");
  const [productImgTwoValidationError, setproductImgTwoValidationError] =
    useState("");
  const [showAlertFeedback, setShowAlertFeedback] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);

//   const [myOrderData, setMyOrderData] = useState([]);
// const [hasData, sethasData] = useState(false);
// const [loading, setLoading] = useState(true);
// const [myOrderNoData, setMyOrderNoData] = useState("");

  const handleShowMore = () => {
    setVisibleItemCount((prevCount) => prevCount + 12);
  };

  const handleCancelOrder = (item) => {
    setIsConfirmationModalOpen(true);
    setIsSelectedProduct(item);
  };
  function diff_hours(dt2, dt1) {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60;
    return Math.abs(Math.round(diff));
  }

  function isCancellable(orderCreatedAt) {
    const createdDate = new Date(orderCreatedAt);
    const nowDate = new Date();
    return diff_hours(nowDate, createdDate) <= 48;
  }

  const OrderDataFetch = async () => {
    try {
      const OrderDataFetchResponse = await OrderService.myOrderList();
      if (JSON.stringify(OrderDataFetchResponse) != "{}") {
        const filteredData = OrderDataFetchResponse.data.map((item, index) => {
          const orderDate = new Date(item.item_status_created_at);
          const formattedOrderDate =
            orderDate.getDate() +
            " " +
            getMonthName(orderDate.getMonth() + 1) +
            " " +
            orderDate.getFullYear() +
            ", " +
            orderDate.toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
              timeZone: "UTC",
            });
        //   let serialNo = <div className="text-center">{index + 1}</div>;
          const placeHolderImage = (
            <div className="itemWrapImageMyOrder">
              <img src={DefaultImage} alt="image" />
            </div>
          );
          const productName = (
            <div className="text-left productNameBlock">
              {item.product_name}
            </div>
          );
          const orderStatus = (
            <p className="orderTxt text-left">
              {item.item_status === "Cancelled" ? (
                <span className="redDot"></span>
              ) : item.item_status === "Dispatched" ? (
                <span className="orangeDot"></span>
              ) : item.item_status === "Delivered" ? (
                <span className="greenDot"></span>
              ) : (
                <span className="yellowDot"></span>
              )}
              {item.item_status === "Cancelled" ? (
                "Cancelled"
              ) : item.item_status === "Dispatched" ? (
                "Dispatched"
              ) : item.item_status === "Delivered" ? (
                "Delivered"
              ) : (
                <>
                  Ordered On{" "}
                  <span className="orderDate">{formattedOrderDate}</span>
                </>
              )}
            </p>
          );
          const actionButtons = (
            <div className="ordersButtonWrap">
              {item.item_status != "Cancelled" && (
                <>
                  <div
                    className="trackOrderTxt"
                    onClick={() => {
                      handleTrackOrder(item.item_id);
                    }}
                  >
                    <PrimaryGradientButton buttonText="Track Order" />
                  </div>
                  <div
                    className="feedbackTrackOrderTxt"
                    onClick={() => handleReviewOrder(item.order_id)}
                  >
                    <PrimaryOutLineButton outlinebuttonText="Feedback" />
                  </div>
                  {item.item_status != "Cancelled" && (
                    <div className="cancelTrackOrderTxt">
                      <Button
                        disabled={!isCancellable(item.order_created_at)}
                        variant="danger"
                        onClick={() => {
                          handleCancelOrder(item);
                        }}
                      >
                        Cancel Order
                      </Button>
                    </div>
                  )}
                  {item.show_button && (
                    <div className="feedbackTrackOrderTxt">
                      <PrimaryOutLineButton
                        onClick={() => {
                          // setOpenConcentModal(true);
                        }}
                        outlinebuttonText="My Consent"
                      />
                    </div>
                  )}
                </>
              )}
              {item.item_status == "Cancelled" && (
                <>
                  <div className="trackOrderTxt">
                    <PrimaryGradientButton
                      onClick={() => {
                        handleTrackOrder(item.item_id);
                      }}
                      buttonText="Track Order"
                    />
                  </div>
                  <div className="feedbackTrackOrderTxt">
                    <PrimaryOutLineButton
                      onClick={() => handleReviewOrder(item.order_id)}
                      disabled={item.item_status == "Cancelled"}
                      outlinebuttonText="Feedback"
                    />
                  </div>
                </>
              )}
            </div>
          );
          return {
            // "Order Id": <div className="text-center">{item.item_id}</div>,
            // "Product Image": placeHolderImage,
            // "Product Name": productName,
            // Quantity: item.item_quantity,
            // "Order Status": orderStatus,
            // Actions: actionButtons,
            "Order Id": <div className="text-center">{item.order_id}</div>,
            "Product Image": placeHolderImage,
            "Product Name": productName,
          };
        });
        setMyOrderData(filteredData);
        sethasData(true);
        setLoading(false);
      } else {
        setMyOrderNoData("No Orders are listed");
        setLoading(false);
        sethasData(false);
      }
    } catch (error) {
      console.error("OrderDataFetch");
      setLoading(false);
      sethasData(false);
      setMyOrderNoData("No Orders are listed");
    }
  };
  useEffect(() => {
    OrderDataFetch();
  }, []);

  function getMonthName(month) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[month - 1];
  }

  function formatDate(date) {
    const d = new Date(date);
    return (
      d.getDate() +
      " " +
      getMonthName(d.getMonth() + 1) +
      " " +
      d.getFullYear() +
      ", " +
      d.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })
    );
  }

  const handleOptionSelection = async (response) => {
    if (response == "Yes") {
      try {
        const userInfo = JSON.parse(localStorage.getItem("userData"));
        const hierId = userInfo.dcm_hierarchies_id;
        const payload = {
          order_id: parseInt(isSelectedProduct.order_id),
          item_id: parseInt(isSelectedProduct.item_id),
          status: "Cancelled",
          contractor_hierarchy_id: parseInt(hierId),
          recredit_points_for: ["Cancelled"],
        };
        const res = await OrderService.cancelOrder(payload);

        if (res.response_code == 200) {
          setIsConfirmationModalOpen(true);
          if (res.data.status) {
            toast.success(res.data.message);

            OrderDataFetch();
          } else {
            toast.error(res.data.message);
          }
          setIsConfirmationModalOpen(false);
        } else {
          setShowAlertConfirm(true);
          setIsLoginSuccess({ isLogin: false, text: res.data.message });
          setTimeout(() => {
            setShowAlertConfirm(false);
            setIsConfirmationModalOpen(false);
          }, 2000);
        }
      } catch (error) {
        console.error("Order Cancel");
      }
    }
    if (response == "No") {
      setIsConfirmationModalOpen(false);
    }
  };

  const handleTrackOrder = (item) => {
    setIsTrackModalOpen(true);
    setIsSelectedProductTrack(item);
  };

  useEffect(() => {
    if (isSelectedProductTrack) {
      const TrackOrder = async () => {
        try {
          const orderId = isSelectedProductTrack;
          const token = localStorage.getItem("access_token");
          const TrackOrderResponse = await OrderService.trackOrder(
            orderId,
            token
          );

          if (TrackOrderResponse.response_code == 200) {
            setOrderTrack(TrackOrderResponse.data.order_track);
          }
        } catch (error) {
          console.error("Track Order");
        }
      };
      TrackOrder();
    }
  }, [isSelectedProductTrack]);

  useEffect(() => {
    const ReasonDataFetch = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const ReasonResponse = await OtherService.reasonListReview(token);
        if (
          ReasonResponse.response_code == 200 &&
          ReasonResponse.data.reasonDetails.length > 0
        ) {
          setIsReasonList(
            ReasonResponse.data.reasonDetails?.map((item, index) => ({
              id: item.id,
              title: item.description,
            }))
          );
        }
      } catch (error) {
        console.error("ReasonDataFetch");
      }
    };
    ReasonDataFetch();
  }, []);

  const resetFeedbackModalState = () => {
    setConfirmReceipt(null);
    setproductConditionSelect(null);
    setoverAllExperience(undefined);
    setIsTextArea("");
    setIsReason({ id: "", title: "" });
    setComplainImage(null);
    setComplainImageTwo(null);
    setexperienceValidationError("");
    setReceiptValidationError("");
    setProductConditionValidationError("");
    setReasonConditionValidationError("");
    setProductImgValidationError("");
    setproductImgTwoValidationError("");
    setShowAlertFeedback(false);
  };

  useEffect(() => {
    if (!isReviewModalOpen) {
      resetFeedbackModalState();
    }
  }, [isReviewModalOpen]);

  const handleReasonChange = (selectedValue) => {
    setIsReason(selectedValue);
    setReasonConditionValidationError("");
  };
  const handleReviewOrder = (itemID) => {
    setIsReviewModalOpen(true);
    setIsSelectedProductReviewOrderId(itemID);
  };
  const handleReviewOptionSelection = (response) => {
    if (response == "Yes" || response == "No") {
      setConfirmReceipt(response);
      setReceiptValidationError("");
    }
    if (response == "Good" || response == "Bad") {
      setproductConditionSelect(response);
      setProductConditionValidationError("");
      if (response === "Bad") {
        // If response is 'Bad', additional validations are required
        // setReasonConditionValidationError("Reason is required.");
        // setProductImgValidationError("Product Image is required.");
        // setproductImgTwoValidationError("Product Image is required.");
      }
    }
    if (
      response == 0 ||
      response == 1 ||
      response == 2 ||
      response == 3 ||
      response == 4
    ) {
      setoverAllExperience(response);
      setexperienceValidationError("");
    }
  };
  const handleOnRevieSubmit = async () => {
    let isValid = true;
    if (overAllExperience == undefined) {
      setexperienceValidationError("Overall experience is required.");
      isValid = false;
    }
    const validations = [
      {
        value: confirmReceipt,
        setter: setReceiptValidationError,
        message: "Confirm receipt of order is required.",
        checkFor: "restOption",
      },
      {
        value: productConditionSelect,
        setter: setProductConditionValidationError,
        message: "Product condition is required.",
        checkFor: "restOption",
      },
      {
        value: isReason.title,
        setter: setReasonConditionValidationError,
        message: "Reason is required.",
        checkFor: "Bad",
      },
      {
        value: complainImage,
        setter: setProductImgValidationError,
        message: "Product Image is required.",
        checkFor: "Bad",
      },
      {
        value: complainImageTwo,
        setter: setproductImgTwoValidationError,
        message: "Product Image is required.",
        checkFor: "Bad",
      },
    ];

    validations.forEach(({ value, setter, message, checkFor }) => {
      if (confirmReceipt === "No") return;
      if (
        (productConditionSelect == "Bad" && checkFor == "Bad" && !value) ||
        (productConditionSelect != "Bad" && checkFor != "Bad" && !value)
      ) {
        setter(message);
        isValid = false;
      } else {
        setter("");
      }
    });

    if (isValid) {
      setIsButtonLoading(true);
      try {
        const formData = new FormData();
        formData.append("order_id", String(isSelectedProductReviewOrderId));
        formData.append("overall_website_rating", overAllExperience);
        formData.append("delivery_confirmation", confirmReceipt);
        formData.append("product_condition", productConditionSelect);
        formData.append("product_condition_description", isReason.title);
        formData.append("overall_suggestion", isTextArea);
        if (complainImage) formData.append("file_1", complainImage.file);
        if (complainImageTwo) formData.append("file_2", complainImageTwo.file);

        const res = await OtherService.reviewCreate(formData);
        if (res.response_code && res.data.status == true) {
          setIsButtonLoading(false);
          toast.success("Thank You for your feedback");
          setTimeout(() => {
            setIsReviewModalOpen(false);
          }, 2000);
        } else {
          setIsButtonLoading(false);
          // setShowAlertFeedback(true)
          toast.error("Thank You for your feedback");
          // setIsLoginSuccess({ isLogin: false, text: res.data.message })
          setIsReviewModalOpen(true);
        }
      } catch (error) {
        console.error("Form Data Response");
      }
    }
  };

  const handleTextReview = (e) => {
    setIsTextArea(e.target.value);
  };
  const setComplainImageHandler = (product) => {
    setComplainImage(product);
    setProductImgValidationError("");
  };
  const setComplainImageTwoHandler = (productTwo) => {
    setComplainImageTwo(productTwo);
    setproductImgTwoValidationError("");
  };
  // ---------------------------

  useEffect(() => {
    // setTimeout(() => {
    //     toast.success("Please select address");
    // }, 1000)
    const UserNameFetchData = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const UserNameFetchResponse =
          await RegistrationService.getBasicProfileInfo(token);
        if (UserNameFetchResponse.success == true) {
          setIsUser(UserNameFetchResponse.response.basicProfileDetails);
          setLoading(false);
        }
      } catch (error) {
        console.error("User Name Fetch");
      }
    };
    UserNameFetchData();
  }, []);
  useEffect(() => {
    const AddressFetchData = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const AddressFetchResponse = await OtherService.allAddresses(token);
        if (AddressFetchResponse.data.status == true) {
          setIsAddress(AddressFetchResponse.data.addressDetails);
          setLoading(false);
        }
      } catch (error) {
        console.error("Address Fetch");
      }
    };
    AddressFetchData();
  }, []);
  const navigate = useNavigate();
  const handleAddNewAddress = () => {
    navigate(`/add-new-address`);
  };

  const chooseAddress = (item) => {
    setSelectedAddress(item);
    if (item.is_old_address == 1) {
      navigate(`/edit-address/${item.id}`);
      return;
    }
    setIsEditAddress(true);
    setIsSelectedAddressChoose(true);
    setIsSelectedAddress(item);
  };
  const handleEditAddress = (addressId) => {
    navigate(`/edit-address/${addressId}`);
  };
  const handleProceed = (addressId) => {
    navigate(`/delivery/${addressId}`);
  };

  const changeBgColor = () => {
    if (window.scrollY < 2820) {
      setBorderActive(true);
    } else {
      setBorderActive(false);
    }
  };

  window.addEventListener("scroll", changeBgColor);  
  

  return (
    <>
      <BreadCrumbSecttion
        pageTitle="My Redemption"
        currentPageName="My Redemption"
      />
      <section className="padTop50">
        <Container ref={ele}>
          <Row>
            {myOrderData?.map((item, index) => {
              const {
                item_id,
                order_id,
                product_name,
                placeHolderImage,
                productName,
                line1,
                line2,
                line3,
                city,
                post_code,
                district_name,
              } = item;
              return (
                <Col xs={12} md={6} lg={4} key={index} className="mb-4">
                  <div className={`addressBlock`}>
                    <div
                      className="addressBlockWrap"
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <div className="addressBlockArea">
                        <div className="addressTxtWrap">
                          {/* <div className="firstBlock">{<div className="itemWrapImageMyOrder"><img src={DefaultImage} alt="image" /></div>}</div> */}
                          <div className="firstBlock">
                                <img
                                    src={DefaultImage}
                                    alt="image"
                                    style={{ width: "117px", height: "150px", objectFit: "cover" }}
                                />
                        </div>

                        {/* <div className="secondBlock">
                            {line1} {line2} {line3}

                        </div> */}
                        <div className="secondBlock">
  {loading ? (
    <p>Loading orders...</p>
  ) : hasData ? (
    myOrderData.map((order, index) => (
      <div key={index} className="orderItemRow">
        {/* You can render however you like — using a table or flex/grid */}
        <div className="orderId">{order["Order Id"]}</div>
        <div className="productImage">{order["Product Image"]}</div>
        <div className="productName">{order["Product Name"]}</div>
      </div>
    ))
  ) : (
    <p>{myOrderNoData}</p>
  )}
</div>

                        </div>
                        {/* <div className="addressTxtWrap">
                          <div className="firstBlock">Address</div>
                          <div className="secondBlock">
                            {line1} {line2} {line3}
                          </div>
                        </div> */}
                        {/* <div className="addressTxtWrap">
                          <div className="firstBlock">District</div>{" "}
                          <div className="secondBlock">{district_name}</div>
                        </div>
                        <div className="addressTxtWrap">
                          <div className="firstBlock">PostCode</div>{" "}
                          <div className="secondBlock">{post_code}</div>
                        </div> */}
                        {/* <div className="addressTxtWrap">
                          <div className="firstBlock">Phone No</div>
                          <div className="secondBlock">{isUser?.phone}</div>
                        </div> */}
                      </div>
                      {item.id == isSelectedAddress.id && isEditAddress && (
                        <span
                          onClick={() => {
                            handleEditAddress(item.id);
                          }}
                          className="editAddress "
                        >
                          <PrimaryGradientButton
                            buttonText="Edit Address"
                            className="mt-3"
                          />
                        </span>
                      )}
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddressList;
